const visibilityMap = new Map();
const listenersMap = new Map();

const isFontOptionVisible = (fontFamily) => visibilityMap.get(fontFamily) || false;

const subscribeToFontOptionVisibility = (fontFamily, callback) => {
  if (!listenersMap.has(fontFamily)) {
    listenersMap.set(fontFamily, new Set());
  }

  listenersMap.get(fontFamily).add(callback);

  return () => {
    listenersMap.get(fontFamily)?.delete(callback);
  };
};

const setFontOptionVisible = (fontFamily) => {
  if (visibilityMap.get(fontFamily)) return;

  visibilityMap.set(fontFamily, true);

  const listeners = listenersMap.get(fontFamily);
  if (listeners) {
    Array.from(listeners).forEach((cb) => cb());
    listenersMap.delete(fontFamily);
  }
};

export { isFontOptionVisible, subscribeToFontOptionVisibility, setFontOptionVisible };
